var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTestBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 4H4.99976C4.44747 4 3.99976 4.44772 3.99976 5V20.5C3.99976 21.0523 4.44747 21.5 4.99976 21.5H18.9998C19.552 21.5 19.9998 21.0523 19.9998 20.5V5C19.9998 4.44772 19.552 4 18.9998 4Z",
    fill: "#3987F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 2.5H8.99976C8.72361 2.5 8.49976 2.72386 8.49976 3V5C8.49976 5.27614 8.72361 5.5 8.99976 5.5H14.9998C15.2759 5.5 15.4998 5.27614 15.4998 5V3C15.4998 2.72386 15.2759 2.5 14.9998 2.5Z",
    fill: "#2C6CCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.812 9.625H13.687C13.3073 9.625 12.9995 9.9328 12.9995 10.3125C12.9995 10.6922 13.3073 11 13.687 11H16.812C17.1917 11 17.4995 10.6922 17.4995 10.3125C17.4995 9.9328 17.1917 9.625 16.812 9.625Z",
    fill: "#D1E6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20878 11.7633L11.423 9.21613C11.6721 8.92957 11.6417 8.49533 11.3552 8.24623C11.0686 7.99712 10.6344 8.02749 10.3853 8.31405L8.17106 10.8612C7.92196 11.1478 7.95232 11.582 8.23888 11.8311C8.52544 12.0802 8.95968 12.0498 9.20878 11.7633Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17502 10.8261L7.67242 9.32354C7.40393 9.05505 6.96863 9.05505 6.70014 9.32354C6.43166 9.59202 6.43166 10.0273 6.70014 10.2958L8.20275 11.7984C8.47123 12.0669 8.90653 12.0669 9.17502 11.7984C9.4435 11.5299 9.4435 11.0946 9.17502 10.8261Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.812 16.125H13.687C13.3073 16.125 12.9995 16.4328 12.9995 16.8125C12.9995 17.1922 13.3073 17.5 13.687 17.5H16.812C17.1917 17.5 17.4995 17.1922 17.4995 16.8125C17.4995 16.4328 17.1917 16.125 16.812 16.125Z",
    fill: "#D1E6FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20952 18.2638L11.4237 15.7166C11.6728 15.4301 11.6425 14.9958 11.3559 14.7467C11.0693 14.4976 10.6351 14.528 10.386 14.8145L8.17179 17.3617C7.92269 17.6482 7.95305 18.0825 8.23961 18.3316C8.52617 18.5807 8.96041 18.5503 9.20952 18.2638Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17526 17.3261L7.67266 15.8235C7.40417 15.5551 6.96887 15.5551 6.70039 15.8235C6.4319 16.092 6.4319 16.5273 6.70039 16.7958L8.20299 18.2984C8.47148 18.5669 8.90678 18.5669 9.17526 18.2984C9.44375 18.0299 9.44375 17.5946 9.17526 17.3261Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTestBlue);
export default __webpack_public_path__ + "static/media/icon_test_blue.2266b584.svg";
export { ForwardRef as ReactComponent };